/**
 *  @class
 *  @function TermsCheckbox
 */
if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.append = this.dataset.append;
      this.terms_checkbox = this.querySelector(`#CartTerms${this.append}`);

      if (this.terms_checkbox) {
        this.terms_checkbox.setCustomValidity(theme.strings.requiresTerms);

        // Delegación de eventos en document: así funciona sin importar
        // si el botón de checkout es reemplazado/regenerado por otros
        // scripts (ej. Hulk) después de que este componente se conecta.
        if (!this._delegatedHandler) {
          this._delegatedHandler = (e) => {
            const button = e.target.closest('.button.checkout-button');
            if (!button) return;
            if (!this.parentNode.contains(button)) return;

            if (!this.terms_checkbox.checked) {
              this.terms_checkbox.reportValidity();
              this.terms_checkbox.focus();
              e.preventDefault();
              e.stopPropagation();
            }
          };
          document.addEventListener('click', this._delegatedHandler, true);
        }
      }
    }

    disconnectedCallback() {
      if (this._delegatedHandler) {
        document.removeEventListener('click', this._delegatedHandler, true);
        this._delegatedHandler = null;
      }
    }
  }
  customElements.define('terms-checkbox', TermsCheckbox);
}